import React from 'react'
export default React.createContext({
  drawerOpening: false,
  setDrawerOpening: () => {},
  currentDrawer: '',
  setCurrentDrawer: () => {},
  arbitratorFormData: {},
  setArbitratorFormData: () => {}
})
